import { render, staticRenderFns } from "./LeaveAttendanceDashboard.vue?vue&type=template&id=c1fee1e4"
import script from "./LeaveAttendanceDashboard.vue?vue&type=script&lang=js"
export * from "./LeaveAttendanceDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports